import { triplaServer } from 'src/apis/server'

export default {
  test(hotelId, botId) {
    return triplaServer
      .post(`api/triplabot/v1/custom_bots/${botId}/test`, {
        hotel_id: hotelId
      })
      .then((res) => res.data)
  }
}
